<ng-container *ngIf="data.fields.Title.value !== ''">
  <div mat-dialog-title>
    <span class="dialog-title-label" *scText="data.fields.Title"></span>
    <button
      *ngIf="data.fields.HasCloseButtonInHeader.value"
      (click)="dismiss()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</ng-container>
<div mat-dialog-content>
  <div *ngIf="data.payment.errorMessage" class="alert alert-danger">
    {{ data.payment.errorMessage }}
  </div>
  <dl class="row">
    <ng-container *ngFor="let item of data.fields.items; let i = index">
      <ng-container *ngIf="data.payment[i]">
        <dt class="col-sm-5 text-sm-right">
          <span *scText="item.fields.label"></span>
          <span *ngIf="data.labels && data.labels[i]">
            {{ data.labels[i] }}</span
          >
        </dt>
        <dd class="col-sm-7">{{ data.payment[i] }}</dd>
      </ng-container>
    </ng-container>
  </dl>
</div>
<div mat-dialog-actions>
  <ng-container
    *ngIf="data.fields.SubmitButtonLabel.value !== '' && !errorState"
  >
    <button
      class="btn btn-primary btn-mid btn-block btn-md-block-none"
      *scText="data.fields.SubmitButtonLabel"
      (click)="confirm()"
    ></button>
  </ng-container>
  <ng-container *ngIf="data.fields.CancelButtonLabel.value !== ''">
    <button
      class="btn btn-link btn-with-icon btn-block btn-md-block-none"
      (click)="dismiss()"
    >
      <span *scText="data.fields.CancelButtonLabel"></span>
    </button>
  </ng-container>
</div>
